export { default } from './short-code-confirmation-modal';
